export default {
      id: "Progress_Notes_regular-usage",
      viewBox: "0 0 44 45",
      url: __webpack_public_path__ + "sprite.6656901b3ab9be5618a76678ad156ea6.svg#Progress_Notes_regular-usage",
      toString: function () {
        return this.url;
      }
    }